// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__bjtnt","labelPrefix":"current-filter-tag_labelPrefix__3bEny"};